<div class="all-in-one-table content-layout">
  <div [ngClass]="elements>5?'example-container':'none'" style="overflow-x:auto;">

    <table mat-table [dataSource]="inboundEmailList" matSort (matSortChange)="sortData($event)"
      style="user-select:none">

      <!-- Dynamic data columns -->
      <ng-container *ngFor="let column of columns" [matColumnDef]="column.property">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ column.name }}
        </th>
        <td mat-cell *matCellDef="let row" [ngClass]="column.cssClasses">


          <ng-container *ngIf="column.property === 'createdDate'">
                         {{row.startDateTime | calsoftDate}}
          </ng-container>

             <ng-container *ngIf="column.property === 'updatedDate'">
            {{row.updatedDate | calsoftDate}}
          </ng-container>

             <ng-container *ngIf="column.property === 'startDateTime'">
            {{ ('1970-01-01T' + row.startTime + ':00') | date:'h : mm a' }}
          </ng-container>

            <ng-container *ngIf="column.property === 'endDateTime'">
           {{ ('1970-01-01T' + row.endTime + ':00') | date:'h : mm a' }}
          </ng-container>

          <ng-container *ngIf="column.property !== 'actions' 
          && column.property !== 'endDateTime'
              && column.property !== 'createdDate'
           && column.property !== 'startDateTime'
            && column.property !== 'updatedDate'">
            {{ row[column.property] }}
          </ng-container>

          <!-- <ng-container *ngIf="column.property=='actions'">

            <button [attr.guide]="'inbound-emails-btn-1' + '__' + sanitizedUrl" type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
              <mat-icon>more_horiz</mat-icon>
            </button>
            <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
              <button [attr.guide]="'inbound-emails-btn-2' + '__' + sanitizedUrl" (click)="editSendEmail(row.id)" mat-menu-item>
                <mat-icon>edit</mat-icon>
                <span>Edit</span>
              </button>
            </mat-menu>
          </ng-container> -->
        </td>

      </ng-container>


      <tr mat-header-row *matHeaderRowDef="visibleColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: visibleColumns;" class="clickable"></tr>
    </table>

    <div class="products-padding" fxLayoutAlign="center center" *ngIf="!inboundEmailList?.length">
      No records found
    </div>

    <div *ngIf="inboundEmailList?.length>0" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">
      <mat-spinner [diameter]="20" *ngIf="spinner"></mat-spinner>
      <mat-paginator class="paginator" (page)="getUpdate($event)" showFirstLastButtons [length]="pageList"
        [pageIndex]="page" [pageSize]="size" [pageSizeOptions]="pageSizeValue"> </mat-paginator>
    </div>
  </div>